/*
 * @Author: your name
 * @Date: 2021-03-26 21:27:39
 * @LastEditTime: 2022-01-22 14:12:23
 * @LastEditors: your name
 * @Description: 路由验证
 * @FilePath: \hz-finance\src\router\guard\permissionGuard.ts
 */

import util from "@util/js";
import { routerGo } from "../constant";

const LOGIN_PATH = "/404";

const whitePathList = [LOGIN_PATH, "/login", '/downCenter'];

let registerRouteFresh = true;

export function createPermissionGuard(router) {
  router.beforeEach(async(to, from, next) => {
    if (whitePathList.includes(to.path)) {
      next();
    } else {
      const token = util.analysisUrl("token");
      if (token) {
        util.setStorage("token", token);
        util.delParam("token");
        next();
      } else {
        const token = util.getStorage("token");
        if (!token || token === "undefined") {
          next({ name: "login" });
        } else {
          if (registerRouteFresh) {
            await routerGo(to, next);
            registerRouteFresh = false;
          } else {
            if (to.matched.length === 0) {
              next("/404");
            } else {
              next();
            }
          }
        }
      }
    }
  });
}